import { SparkleIcon } from "@phosphor-icons/react";
import { defaultSections } from "@reactive-resume/schema";
import { RichInput } from "@reactive-resume/ui";

import { AiActions } from "@/client/components/ai-actions";
import { useResumeStore } from "@/client/stores/resume";

export const SummaryInlineSection = () => {
  const section = useResumeStore(
    (state) => state.resume.data.sections.summary ?? defaultSections.summary,
  );
  const setValue = useResumeStore((state) => state.setValue);

  return (
    <section className="mx-auto w-full max-w-[720px] pb-3">
      <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-emerald-600">
        Profil professionnel
      </p>
      <h1 className="mt-1.5 text-2xl font-bold tracking-tight text-indigo-950 sm:text-[28px]">
        Présentez votre valeur
      </h1>
      <p className="mt-1.5 max-w-lg text-xs leading-5 text-slate-500 sm:text-sm">
        Résumez votre expertise, vos forces et votre objectif en quelques lignes.
      </p>

      <div className="mt-5 rounded-2xl border border-indigo-100 bg-white p-4 shadow-sm">
        <div className="mb-3 flex items-start gap-2 rounded-xl bg-indigo-50/70 p-3 text-[11px] leading-4 text-indigo-900">
          <SparkleIcon size={17} weight="fill" className="shrink-0 text-emerald-500" />
          Un profil efficace tient en trois à cinq phrases et reste adapté au poste ciblé.
        </div>
        <RichInput
          content={section.content}
          onChange={(value) => setValue("sections.summary.content", value)}
          footer={(editor) => (
            <AiActions
              value={editor.getText()}
              onChange={(value) => {
                editor.commands.setContent(value, true);
                setValue("sections.summary.content", value);
              }}
            />
          )}
        />
      </div>
    </section>
  );
};
